module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    attrs: {
      "name": _vm.name
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("- Select -")]), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option[_vm.valueField || 'id'],
        "selected": option[_vm.valueField || 'id'] == _vm.value
      }
    }, [_vm._v(_vm._s(option[_vm.titleField || 'title']))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e9dd38b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/select-input.vue
// module id = 463
// module chunks = 2